module.exports = __webpack_public_path__ + "587868f2ba21caaad89c6bf2a0020bbc.png";